//'use strict';
export default class FooterSectionController {

    constructor() {
        let vm = this;
        vm.header = 'Wealth Distribution Atlas';
        vm.description = 'Wealth data by segment can be used to spot new markets for many products, particularly those in the luxury industry, and can help to position products alongside value/premium offerings. Learn more about the entire spectrum of wealth segment sizes and trends around the world in the interactive chart below. You can switch between the five net-wealth segments by clicking on the corresponding segment button.';
    }
}
FooterSectionController.$inject = [];



// WEBPACK FOOTER //
// ./src/app/views/footer-section/footer-section.controller.js